import { fork, all } from 'redux-saga/effects';
import { eventSaga } from '../app/pages/EventDetailsPage/slice/saga';
import { ticketSaleSaga } from '../app/pages/TicketSalePage/slice/saga';
import { cartSaga } from './cartSlice/saga';
import { userSaga } from './userSlice/saga';

export default function* rootSaga() {
  return yield all([
    fork(eventSaga),
    fork(ticketSaleSaga),
    fork(cartSaga),
    fork(userSaga),
  ]);
}
